import { RecipeHeader } from './recipe-header.models';

export interface RecipeDetail {
  RecipeDetailId: string;
  RecipeHeaderId: string;
  RecipeDetailTypeEnum: number;
  SubRecipeHeaderId?: string;
  RecipeIngredientId?: string;
  Sequence: number;
  Quantity: number;
  UnitOfMeasureTypeEnum: number;
  UnitOfMeasureName: string;
  UnitOfMeasureAbbreviation: string;
  PercentYield?: number;
  CostOverride?: number;
  BasePercentYield?: number;
  BaseCostOverride?: number;
  CreateDate: Date | string;
  ChangeDate: Date | string;
  DeleteDate?: Date | string;
  Description: string;
  IsGenericIngredient: boolean;
  HasProductLink: boolean;
  PreparationMethod: string;
  ConversionUnitOfMeasureTypeEnum: number;
  ConversionUnitOfMeasureName: string;
  ConversionUnitOfMeasureAbbreviation: string;
  ConversionServingsPerCase: number;
  IsEditable: boolean;
  CanViewDetails: boolean;
  IsPrivate: boolean;
}

export interface CreateRecipeDetailRequest {
  RecipeHeaderId: string;
  SubRecipeHeaderId?: string;
  RecipeIngredientId?: string;
  Sequence: number;
  Quantity: number;
  UnitOfMeasureTypeEnum: number;
  PercentYield?: number;
  CostOverride?: number;
  CustomerId: string;
  PreparationMethod: string;
  ConversionUnitOfMeasureTypeEnum: number;
  ConversionServingsPerCase: number;
}

export type CreateRecipeDetailsRequest = {
  RecipeHeaderId: string;
  Ingredients: string;
  CustomerId: string;
};

export interface UpdateRecipeDetailRequest {
  RecipeDetailId: string;
  Sequence: number;
  Quantity: number;
  UnitOfMeasureTypeEnum: number;
  PercentYield?: number;
  CostOverride?: number;
  CustomerId: string;
  PreparationMethod: string;
  ConversionUnitOfMeasureTypeEnum: number;
  ConversionServingsPerCase: number;
}

export interface DeleteRecipeDetailRequest {
  RecipeHeaderId: string;
  RecipeDetailId: string;
  CustomerId: string;
}

export enum RecipeDetailType {
  Ingredient = 0,
  SubRecipeHeader = 1,
}

export interface RecipeDetailHeader {
  RecipeHeader: RecipeHeader;
  RecipeDetail: RecipeDetail;
}

export interface SequenceRecipeDetailsRequest {
  RecipeHeaderId: string;
  CustomerId: string;
  Details: SequenceRecipeDetail[];
}

export interface SequenceRecipeDetail {
  RecipeDetailId: string;
  Sequence: number;
  Description: string;
}
